import React, {useState} from 'react';

import {BotPageResult} from '../../../../server/routes/main.js'

interface BotProps {
    server: string;
    pageData: unknown;
}

export default function Bot({server, pageData}: BotProps) {

    const typedPageData = pageData as BotPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <div dangerouslySetInnerHTML={{__html:data.html}} />
        </>
	)
}
